import api from "./api"

export const sendVerificationEmail = async (): Promise<void> => {
  await api.put("/auth/verify-email")
}

export const verifyEmail = async (code: string): Promise<void> => {
  await api.post("/auth/verify-email", { code })
}
